import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {DataTableLocalization} from "../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {connect} from "trim-redux";
import MaterialTable from "material-table";
import {tableIcons} from "../../../../config/design/TableIcons";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import moment from "jalali-moment";
import {TableCount, TablePage} from "../../../../config/Permissions";
import Container from "@material-ui/core/Container/Container";
import Typography from "@material-ui/core/Typography/Typography";
import {Translate} from "../../../../config/Translate";
import AppCardLoaderTable from "../../../components/Skeletons/AppCardLoaderTable";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {changeURL, colors, currencySymbol, getMediaURL, price, truncate} from "../../../../config/values";
import Button from "@material-ui/core/Button/Button";
import { Link as ReactLink } from "react-router-dom";
import FilterListRoundedIcon from "@material-ui/icons/FilterListRounded";
import {Grid, MenuItem} from "@material-ui/core";
import TextField from "@material-ui/core/TextField/TextField";
import queryString from "query-string";
import OpenInNewRoundedIcon from "@material-ui/icons/OpenInNewRounded";
import MakeIncomeSharingButton from "./MakeIncomeSharingButton";

class IncomeSharing extends React.Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    state = {
        columns: [
            {
                field: 'thumbnail',
                editable: 'never',
                filtering: false,
                sorting:false,
                hidden: this.props.width === "xs",
                title: Translate.thumbnail,
                render: rowData =>
                    <a href={`${defaultVariabls.website}/product/${rowData.product?.slug}`} target="_blank" style={{position:"relative",display:"block"}}>
                        <img alt="avatar" src={getMediaURL(rowData.product?.thumbnail,'small')} className={this.classes.FMThumbnail}/>
                        {
                            rowData.product?.situation === "worked" &&
                            <div style={{position:"absolute",bottom:0,padding:2,textAlign:"center",right:0,width:50,backgroundColor:"#232f3e",borderRadius:"0 0 4px 4px"}}>
                                <span style={{color:"#fff",fontSize:9,whiteSpace:"nowrap"}}>{Translate.worked}</span>
                            </div>
                        }
                    </a>
            },
            {
                title: Translate.productName,
                field: 'name',
                sorting:false,
                filterPlaceholder: Translate.search,
                render: rowData =>
                    <>
                        <Button
                            size="small"
                            startIcon={<OpenInNewRoundedIcon color="primary"/>}
                            component="a"
                            href={`${defaultVariabls.website}/product/${rowData.product?.slug}`}
                            target="_blank"
                        >
                            {truncate(rowData.product?.name,17)}
                        </Button>
                        <br/>

                    </>

            },
            {
                title: Translate.physically,
                field: 'physically',
                sorting:false,
                filterPlaceholder: Translate.search,
                render: rowData =>
                    Translate[rowData.product?.physically]
            },
            {
                title: Translate.shopName,
                field: 'shop',
                sorting:false,
                filterPlaceholder: Translate.search,
                render: rowData =>
                    truncate(rowData.shop?.name,17)
            },
            {
                title: Translate.sharingPercent,
                field: 'percent',
                sorting:false,
                filterPlaceholder: Translate.search,
                render: rowData =>
                    `${rowData.percent}%`
            },

            {
                title: Translate.activity,
                field: 'activity',
                render: rowData =>
                    <>
                        <MakeIncomeSharingButton item_id={rowData.id} reload={() => this.loadData()}/>
                    </>
            }
        ],
        data: [],
        status: 'all',
        date: 'all',
        loading:false,
        ChangeLoader:false
    };
    async componentDidMount(){
        await this.loadDefaults();
    }
    componentWillUnmount(){
        changeURL({search: this.state.search})
    }
    async loadDefaults(){
        const values = queryString.parse(window.location.search);
        let status = values.status;
        let date = values.date;
        let page = values.page;
        let per_page = values.per_page;
        let order_by = values.order_by;
        let order_dir = values.order_dir;
        if(!!status){
            await this.setState({
                status,
            })
        }
        if(!!date){
            await this.setState({
                date,
            })
        }
        if(!!page){
            await this.setState({
                def_page:page,
            })
        }
        if(!!per_page){
            await this.setState({
                per_page:per_page,
                def_per_page:per_page,
            })
        }
        if(!!order_by){
            await this.setState({
                order_by:order_by,
                order_dir:order_dir,
            })
        }
        await this.setState({
            loading:false,
        })
    }
    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()
    }
    handleRemoveItem(id){
        let data = new FormData();
        data.append('id', id);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/income-sharing/remove`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.dataRemoved, {
                    variant: 'success',
                });
                this.loadData();
            })
            .catch(error => {
                this.props.enqueueSnackbar(Translate.dataRemovingFailed, {
                    variant: 'error',
                });

            });

        this.setState({
            loading:false,
            SubmitLoading:false
        });
    }
    async handleChangeStatus(e) {
        this.setState({
            ChangeLoader:true
        })
        let target = e.target;
        let status = target.value;
        await this.setState({
            status
        });
        changeURL({status: target.value});
        this.loadData();
    }
    async handleChangeDate(e) {
        this.setState({
            ChangeLoader:true
        })
        let target = e.target;
        let date = target.value;
        await this.setState({
            date
        });
        changeURL({date: target.value});
        this.loadData();
    }
    async onDelete(id,hasNotif = true) {
        let data = new FormData();
        data.append('item_id', id);
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.post(`${defaultVariabls.url}/income-sharing/delete`, data, config)
            .then(response => {
                if(response.data.hasError){
                    this.props.enqueueSnackbar(response.data.message, {
                        variant: 'error',
                    });
                }else{
                    if(hasNotif){
                        this.props.enqueueSnackbar(Translate.deleteData, {
                            variant: 'success',
                        });
                    }
                }
                this.loadData();

                return true
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.deleteDataFailed, {
                    variant: 'error',
                });
                return false
            });
    }
    render(){
        let {status,date} = this.state;
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        return (
            <>
                {
                    this.state.loading ? <AppCardLoaderTable/> :
                        <Container maxWidth="xl" className={!!this.props.widget ? "thin-table" : null}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <MaterialTable
                                        tableRef={this.tableRef}
                                        icons={tableIcons}
                                        title={<MakeIncomeSharingButton reload={() => this.loadData()}/>}
                                        localization={DataTableLocalization}
                                        columns={this.state.columns}
                                        data={query =>
                                            new Promise((resolve, reject) => {
                                                axios.get(`${defaultVariabls.url}/income-sharing/quickView?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}&status=${status}&date=${date}`, config)
                                                    .then(response => {
                                                        let data = [];
                                                        // eslint-disable-next-line
                                                        response.data.data.map((row) => {
                                                            data.push({
                                                                id: row.id,
                                                                product: row.product,
                                                                shop: row.shop,
                                                                percent: row.percent,
                                                                created_at: row.created_at,
                                                            })
                                                        });
                                                        resolve({
                                                            data: data,
                                                            page: response.data.current_page - 1,
                                                            totalCount: response.data.total,
                                                        })
                                                    }).catch(error => {
                                                    console.log(error.response)
                                                })
                                            })
                                        }
                                        options={{
                                            pageSize: TablePage,
                                            pageSizeOptions: TableCount,

                                        }}
                                        editable={{
                                            onRowDelete: oldData =>
                                                new Promise(resolve => {
                                                    setTimeout(() => {
                                                        resolve();
                                                        this.onDelete(oldData.id);
                                                        this.setState(prevState => {
                                                            const data = [...prevState.data];
                                                            data.splice(data.indexOf(oldData), 1);
                                                            return { ...prevState, data };
                                                        });
                                                    }, 600);
                                                }),
                                        }}
                                    />
                                </Grid>
                            </Grid>

                        </Container>
                }
            </>

        );
    }
}

const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(IncomeSharing)))));